import { createFileRoute, redirect } from '@tanstack/react-router'
import { BetaRequestsPage } from '@/pages/BetaRequests/BetaRequestsPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/beta-requests')({
  component: BetaRequestsPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/beta-requests')) {
      throw redirect({ to: '/' })
    }
  },
})
